import {IManagableObject} from "../../IManagableObject";
import { ReportTemplateColumnViewModel } from "./ReportTemplateColumnViewModel";

export class ReportTemplateViewModel implements IManagableObject {
  Id: number = 0;
  Name: string;
  Type: number = 0;
  Columns: ReportTemplateColumnViewModel[] = [];
  GroupByObject: boolean = false;
  
  init(data?: any) {
    if (data) {
      this.Id = data["id"];
      this.Name = data["name"];
      this.Type = data["type"];

      var columns = data["columns"]
      for (var i = 0; i < columns.length; i++)
        this.Columns.push(ReportTemplateColumnViewModel.fromJS(columns[i]));
      this.GroupByObject = data["groupByObject"];
    }
  }

  static fromJS(data: any): ReportTemplateViewModel {
    data = typeof data === 'object' ? data : {};
    let result = new ReportTemplateViewModel();
    result.init(data);
    return result;
  }

  IsChecked: boolean;
}
